import React from 'react';
import './UILegalView.css';
import UIBrand from '../_commons/Brand/UIBrand';
import UIFooter from '../_commons/Footer/UIFooter';

export default class UIImpressumView extends React.Component {

    componentDidMount() {
        window.scrollTo({ top: 0, behavior: 'instant' });
    }

    render() {
        const { onBack } = this.props;
        return (
            <div className="UILegalView">

                <header className="legal-header">
                    <div className="legal-header-inner">
                        <UIBrand onClick={onBack} />
                        <button className="legal-back-btn" onClick={onBack}>← Zurück</button>
                    </div>
                </header>

                <section className="legal-content">
                    <div className="legal-content-inner">
                        <h1>Impressum</h1>
                        <span>
                        D. Кrаus<br/>
                        jаwb sоftwаre UG(Hаftungsbeschränkt)<br/>
                        Waldstr. 14, D-75399 Unterreichenbach<br/>
                        Die Umsatzsteuer-Identifikationsnummer lautet: DE316073428
                        <br/>
                        <br/>

                        Handelsregister<br/>
                        Amtsgericht Stuttgart<br/>
                        HRB 769567<br/>
                        <br/>

                        Kontakt<br/>
                        E-Mail: contact@dorffuchs.de<br/>
                        <br/>

                        </span>

                    </div>
                </section>

                <UIFooter />
            </div>
        );
    }
}

